import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { useParams } from 'react-router-dom'
import { useGetAccountsByHTG, useGetSalesIds } from '../hooks/api/accounts'
import { useEditUser, useGetUser } from '../hooks/api/users'
import AdminUserForm from '../components/admin/admin-user-form'
import { preprocessUserFormValues } from '../utils/formValues'
import { HTG_COMPANIES } from '../constants/companies'

const EditUser = () => {
  const { userId } = useParams()
  const navigate = useNavigate()
  const [accounts, setAccounts] = useState({})
  const [initialValues, setInitialValues] = useState({})

  const { data: accs, isLoading: isLoadingAccount } = useGetAccountsByHTG(
    { htg: HTG_COMPANIES },
    {
      refetchOnWindowFocus: false,
    }
  )
  const { data: salesIds, isLoading: isLoadingSales } = useGetSalesIds({
    refetchOnWindowFocus: false,
  })
  const { data: user } = useGetUser(userId, { refetchOnWindowFocus: false })
  const editUser = useEditUser()
  const { enqueueSnackbar } = useSnackbar()

  const submitHandler = async (values) => {
    preprocessUserFormValues(values, accounts)

    const res = await editUser.mutateAsync(values)

    if (res?.status === 200) {
      enqueueSnackbar(`${values.email} is updated`, {
        variant: 'success',
      })
    }
  }

  useEffect(() => {
    if (user) {
      const configs = []

      if (user?.isActive) configs.push('isActive')

      if (user?.isAdmin) configs.push('isAdmin')

      setInitialValues({ ...user, configs })
    }
  }, [user])

  useEffect(() => {
    if (_.isPlainObject(accs)) {
      setAccounts({ ...accounts, ...accs })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accs])

  const onSubmit = (handleSubmit, form) => (event) => {
    handleSubmit(event)
      .then(() => navigate('/admin'))
      .catch((err) => {
        enqueueSnackbar(err?.response?.data?.message || 'Unknown error', {
          variant: 'error',
        })
        form.reset()
      })
  }

  return (
    <AdminUserForm
      initialValues={initialValues}
      accounts={accounts}
      salesIds={salesIds}
      submitHandler={submitHandler}
      onSubmit={onSubmit}
      title='Edit user'
      submitButtonText='Update'
      disableEmail={true}
      isLoadingAccount={isLoadingAccount}
      isLoadingSales={isLoadingSales}
    />
  )
}

export default EditUser
